module.exports = __webpack_public_path__ + "static/img/ysj.9c1ddddd.jpg";